import { render, staticRenderFns } from "./PCView.vue?vue&type=template&id=66d18deb&scoped=true"
import script from "./PCView.vue?vue&type=script&lang=js"
export * from "./PCView.vue?vue&type=script&lang=js"
import style0 from "./PCView.vue?vue&type=style&index=0&id=66d18deb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d18deb",
  null
  
)

export default component.exports